/** 版本 */
export enum projectVersionStatus {
  /** 入门版 */
  Start = 1,
  /** 基础版 */
  Basic,
  /** 专业版 */
  Professional,
}
